export default "__VITE_ASSET__DBLgkRui__"